import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import naPortAutocompleteField from './NaPortAutocompleteField'

function NaUSPortAutocompleteField(props) {
  return naPortAutocompleteField(
    props,
    CodeMaintenanceType.DOC_PORT,
    "CBP_PORT"
  )
}

export default NaUSPortAutocompleteField